import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import HomeSlider from './Slider/Slider'

class HomeSliderIntro extends Component {
  static propTypes = {
    sliderItems: PropTypes.arrayOf(Object),
  }

  static defaultProps = {
    sliderItems: [],
  }

  render() {
    const {
      sliderItems,
    } = this.props

    return (
      <React.Fragment>
        <HomeSlider results={sliderItems} />
      </React.Fragment>
    )
  }
}


export default connect(
  ({
    main,
    browser,
  }) => ({
    sliderItems: main.setting.widgetSlider.sliderItems,
    browser,
  }),
)(HomeSliderIntro)
